import React, { useEffect } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { svgIcons } from '../../../style/fonts/SvgIcons'
import TextField from '../../../core/common/textFields/TextField'
import { InputMask } from '@react-input/mask'
import { useGetuserProfileQuery, useUpdateUserProfileMutation } from '../../../services/EndPointsApis'
import { useDispatch, useSelector } from 'react-redux'
import { customStyles } from '../../../core/common/Custom Style/CustomStyle'
import Select from 'react-select'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import { setProfileDetails } from '../../../Features/authslice'
import * as Yup from "yup";

const ProfileTab = () => {
    const userId = useSelector((state: any) => state.auth.userDetail?.userAccountID);
    const { data: userProfile, refetch } = useGetuserProfileQuery({ userId: userId })
    const dispatch = useDispatch()
    const [
        updateProfile,
        { data: profileData, isSuccess, isError, error, isLoading },
    ] = useUpdateUserProfileMutation();

    const profileSchema = Yup.object().shape({
        firstName: Yup.string()
            .required("First Name is required"),
        lastName: Yup.string()
            .required("Last Name is required"),
        contact: Yup.string()
            .required("Contact is required"),
    })

    const initialValues = {
        userId: 0,
        imageURL: "",
        firstName: "",
        lastName: "",
        email: "",
        contact: "",
        businessUnit: {
            id: 0,
            value: ""
        },
        team: [
            {
                id: 0,
                value: ""
            }
        ],
        roles: [
            {
                id: 0,
                value: ""
            }
        ],
        addressLine1: "",
        addressLine2: "",
        zipCode: "",
        state: "",
        city: ""
    }
    const formik = useFormik({
        initialValues,
        validationSchema: profileSchema,
        onSubmit: (values) => {
            updateProfile(values)
        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success('User Updated Successfully');
            refetch()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error]);

    useEffect(() => {
        if (userProfile?.result) {
            formik.setValues({ ...userProfile?.result });
            dispatch(
                setProfileDetails(userProfile?.result)
            );
        }
    }, [userProfile]);

    const selectValuesTeams = userProfile?.result?.team
        ? userProfile.result?.team
            ?.filter((teams: { id: number; value: string }) => teams?.id !== 0 && teams?.value !== '')
            ?.map((teams: { id: number; value: string }) => ({
                value: teams?.id,
                label: teams?.value,
            }))
        : [];
    const selectValuesRoles = Array.isArray(userProfile?.result?.roles)
        ? userProfile.result?.roles
            .filter((role: { id: number; value: string }) => role?.id !== 0 && role?.value !== '')
            .map((role: any) => ({
                value: role.id,
                label: role.value,
            }))
        : [];

    return (
        <>
            <div className="settings-header">
                <h4>Profile Settings</h4>
            </div>
            <div className="settings-form">
                <form onSubmit={formik.handleSubmit}>
                    <div className="form-wrap">
                        <div className="profile-upload">
                            <div className="profile-upload-img">
                                <img
                                    src={userProfile?.result?.imageURL || "/assets/img/profiles/default-upload-img.svg"}
                                    alt="img"
                                    className="profile-img"
                                />
                            </div>
                            {/* <div className="profile-upload-content">
                                <label className="profile-upload-btn">
                                    <i className="ti ti-file-upload" /> Change Image
                                    <input
                                        type="file"
                                        id="imag"
                                        className="input-img"
                                    />
                                </label>
                                <p>JPG, GIF or PNG. Max size of 800K</p>
                            </div> */}
                        </div>
                    </div>
                    <>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="First Name"
                                        type="text"
                                        minLength={3}
                                        maxLength={15}
                                        required
                                        {...formik.getFieldProps("firstName")}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[A-Za-z]*$/.test(value)) {
                                                formik.setFieldValue("firstName", value);
                                            }
                                        }}
                                    />
                                </div>
                                {formik.touched.firstName && formik.errors.firstName && (
                                    <div className="error">{formik.errors.firstName}</div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="Last Name"
                                        type="text"
                                        minLength={3}
                                        maxLength={15}
                                        required
                                        {...formik.getFieldProps("lastName")}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[A-Za-z]*$/.test(value)) {
                                                formik.setFieldValue("lastName", value);
                                            }
                                        }}
                                    />
                                </div>
                                {formik.touched.lastName && formik.errors.lastName && (
                                    <div className="error">{formik.errors.lastName}</div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="Email"
                                        type="text"
                                        value={userProfile?.result?.email || ''}
                                        disabled

                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="input-label">
                                    Phone No. <span className="text-danger">*</span>
                                </label>

                                <InputMask mask="(___) ___-____"
                                    replacement={{ _: /\d/ }}
                                    className="form-control"
                                    {...formik.getFieldProps("contact")}
                                />
                                {formik.touched.contact && formik.errors.contact && (
                                    <div className="error">{formik.errors.contact}</div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="Business Unit"
                                        type="text"
                                        value={userProfile?.result?.businessUnit?.value || ''}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-wrap mb-0">
                                    <label className="input-label">
                                        Teams
                                    </label>

                                    <Select
                                        isMulti={true}
                                        styles={customStyles}
                                        className="select multi-select"
                                        value={
                                            selectValuesTeams
                                        }
                                        isDisabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-wrap mb-0">
                                    <label className="input-label">
                                        Roles
                                    </label>
                                    <Select
                                        isMulti={true}
                                        styles={customStyles}
                                        className="select multi-select"
                                        value={
                                            selectValuesRoles
                                        }
                                        isDisabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="Address Line 1"
                                        type="text"
                                        value={userProfile?.result?.addressLine1 || ''}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="Address Line 2"
                                        type="text"
                                        value={userProfile?.result?.addressLine2 || ''}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="State/Region"
                                        type="text"
                                        placeholder="state"
                                        disabled
                                        value={userProfile?.result?.state || ''}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="City"
                                        type="text"
                                        placeholder="city"
                                        disabled
                                        value={userProfile?.result?.city || ''}
                                    />
                                </div>
                                {/* {formik.touched.city && formik.errors.city && (
                                    <div className="error">{formik.errors.city}</div>
                                )} */}
                            </div>
                            <div className="col-md-3">
                                <div className="form-wrap mb-0">
                                    <label className='input-label'>Zipcode</label>
                                    <InputMask mask="_____-____"
                                        replacement={{ _: /\d/ }}
                                        placeholder=""
                                        className="form-control"
                                        value={userProfile?.result?.zipCode || ''}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-wrap mb-0">
                                    <TextField
                                        label="Country"
                                        type="text"
                                        value={'USA'}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>

                    </>

                    <div className="submit-button d-flex justify-content-end">
                        <button type="submit" className="btn btn-primary">
                            {isLoading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default ProfileTab